import React, { useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import ErrorPage from 'next/error';
import Story from '../../endpoints/Story/Story';
import ContentGrid from '../../grids/ContentGrid';
import Sidebar from '../../components/Sidebar/Sidebar';
import fetcher from '../../utils/fetcher';
import STORYQUERY from '../../endpoints/Story/StoryQuery';
import { parseEmbeddedAssets } from '../../utils/utils';
import { getServerSession } from 'next-auth';
import { authOptions } from 'pages/api/auth/[...nextauth]';
import AdCategoriesContext from 'context/AdCategoriesContext';

const StoryPage = ({ data, errorCode }) => {
  if (errorCode) return <ErrorPage statusCode={errorCode} />;
  const context = useContext(AdCategoriesContext);

  let viafouraJson, useViafoura, livechatJson, useLivechat;
  if (data.viafoura?.json) {
    viafouraJson = JSON.parse(data.viafoura.json);
    useViafoura = viafouraJson.slugs.find(
      (stry) => stry.slug == data.story.canonicalSlug
    );
  }
  if (data.livechat?.json) {
    livechatJson = JSON.parse(data.livechat.json);
    useLivechat = livechatJson.slugs.find(
      (stry) => stry.slug == data.story.canonicalSlug
    );
  }

  useEffect(() => {
    if (data.story.primaryCollection) {
      context.setPrimaryCategory(
        data.story?.primaryCollection.canonicalSlug || 'ros'
      );
    }
    if (data.story.collections) {
      context.setAdCategories(
        data.story?.collections.map((coll) => coll.canonicalSlug)
      );
    }
  }, [data.canonicalSlug]);

  return (
    <ContentGrid
      className="story-content-grid"
      sidebar={
        <Sidebar pageTopic={data.story.title} useViafoura={useViafoura} />
      }
    >
      <div id="mainContent"></div>
      <Story
        minimal={false}
        data={data}
        useViafoura={useViafoura}
        useLivechat={useLivechat}
      />
    </ContentGrid>
  );
};

export async function getServerSideProps({
  query: { slug, previewToken },
  req,
  res,
}) {
  let data,
    errorCode = null,
    layout = 'default';

  await fetcher(STORYQUERY, {
    contentAreaSlug: process.env.CONTENT_AREA_SLUG,
    slug: slug.join('/'),
    previewToken: previewToken,
  })
    .then((result) => {
      data = result;
      if (data?.story?.embeddedAssets) {
        parseEmbeddedAssets(data.story.embeddedAssets);
      }

      if (res) {
        res.setHeader('Cache-Control', 'public, max-age=60');
      }

      if (!data.story) {
        res.statusCode = 404;
        errorCode = res.statusCode > 200 ? res.statusCode : false;
      } else {
        layout = data?.story?.primaryCollection?.templateName;
      }
      if (
        res &&
        data?.story?.canonicalSlug &&
        data.story.canonicalSlug !== slug.join('/')
      ) {
        res.writeHead(301, {
          Location: `/story/${data.story.canonicalSlug}`,
        });
        res.end();
      }
    })
    .catch(() => {
      if (res) {
        res.statusCode = 404;
        errorCode = res.statusCode > 200 ? res.statusCode : false;
      }
    });
  const session = await getServerSession(req, res, authOptions);

  if (typeof layout == 'undefined') {
    layout = 'default';
  }

  return {
    props: {
      data,
      errorCode,
      layout,
      session,
      resourceType: data?.story?.resourceType || 'story',
    },
  };
}

StoryPage.propTypes = {
  errorCode: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
  data: PropTypes.object,
};

export default StoryPage;
